import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

let initialized = false;
export const initializeMsal = async () => {
  if (initialized) return;
  await msalInstance.initialize();
  initialized = true;

  const response = await msalInstance.handleRedirectPromise();
  const account = response?.account ?? msalInstance.getAllAccounts()[0];
  if (account) msalInstance.setActiveAccount(account);
};
